import React, { useState } from 'react';
import { Coin } from '../../data/coins';
import { getCoinImageUrl } from '../lib/imageUrl';

interface AlbumSlotProps {
  coin: Coin;
  count: number;
  onHover: (coin: Coin, count: number, e: React.MouseEvent<HTMLElement>) => void;
  onLeave: () => void;
  onClick: (coin: Coin, count: number, e: React.MouseEvent<HTMLElement>) => void;
  size?: 'normal' | 'small';
}

export const AlbumSlot: React.FC<AlbumSlotProps> = ({
  coin,
  count,
  onHover,
  onLeave,
  onClick,
  size = 'normal'
}) => {
  const [imgError, setImgError] = useState<boolean>(false);
  const isOwned = count > 0;
  const thumbSrc = getCoinImageUrl(coin.imagePath, 'thumbnails');

  return (
    <div
      className={`album-slot size-${size} ${isOwned ? 'owned' : 'missing'}`}
      onMouseEnter={(e) => onHover(coin, count, e)}
      onMouseLeave={onLeave}
      onClick={(e) => onClick(coin, count, e)}
    >
      {!imgError && thumbSrc ? (
        <img
          src={thumbSrc}
          alt={coin.name}
          className="album-slot-img"
          onError={() => setImgError(true)}
          loading="lazy"
        />
      ) : (
        <div className="album-slot-placeholder">
          <span>{coin.year}</span>
        </div>
      )}
    </div>
  );
};
